import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_NUMBER = '919497672523';
const WHATSAPP_MESSAGE = encodeURIComponent('Hi! I need help with pet care on Petzify.');

const WhatsAppWidget = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Petzify on WhatsApp"
      className={`fixed bottom-[4.5rem] right-4 md:bottom-6 md:right-6 z-40 flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#25D366] shadow-lg transition-all duration-500 hover:scale-110 hover:shadow-xl ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <FaWhatsapp size={30} color="white" />
    </a>
  );
};

export default WhatsAppWidget;
